import type { StackProps } from '@mui/material';
import { Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import { rustWebAppProcessData } from './OurProcess.data';
import { StyledStack, StyledSection, SectionNameBannerStack } from './styles';

export const OurProcess = ({ ...props }: StackProps): React.ReactElement => {
  const customThresholds = [0, 25, 45, 60, 75, 90];

  return (
    <>
      <StyledSection width="normal" id="rust-web-app-our-process">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner
              type="section"
              text="Rust Web Development Process"
              color="orange"
            />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title="Our Process"
        description={`We start with architecture design that matches Rust's strengths to your specific needs, then build in rapid 1-2 week sprints so you see progress continuously. Every delivery includes comprehensive testing, performance profiling, and clear documentation - plus we train your team (if you have one) so they can maintain and extend the code confidently after we're done.`}
        data={rustWebAppProcessData}
        height={'320px'}
        thresholds={customThresholds}
      />
    </>
  );
};
